export default __webpack_public_path__ + "locales/el-GR/Webhooks.json?hash=06b70872c1b7f245a776883e83b6ea51";